import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { EmptyRecRepFilter, Filter, IRecRepFilter } from "./Filter";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { ITimesheet, VerifyStatus } from "../../../models/Timesheet";
interface ITimeSheetReport {
}

export const TimeSheetReport = () => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITimeSheetReport>, loading: boolean });
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);
    const [filter, setFilter] = useState<IRecRepFilter>(EmptyRecRepFilter);
    const [tableLoad, setTableLoad] = useState(false);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Timesheets Report</h5>
        </div>
    );

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Timesheet", "GET", null, `filter=${JSON.stringify(filter)}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const startDate = (rowData: any) => {
        let date;
        if (rowData.start_Date) date = format(new Date(rowData.start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const status = (rowData: ITimesheet) => {
        return <span style={{ color: (rowData.verify_Status === VerifyStatus.UnVerified) ? "red" : "black" }}>{rowData.verify_Status ? VerifyStatus[rowData.verify_Status] : ''}</span>;
    };

    const rowClass = (data: ITimesheet) => {
        return {
            'bg-green-300 text-black': data.verify_Status === VerifyStatus.Verified,
            'bg-yellow-100 text-black': data.verify_Status === null || data.verify_Status === VerifyStatus.Pending,
            'bg-pink-100 text-black': data.verify_Status === VerifyStatus.Rejected,
        };
    };

    const addedByTemplate = (rowData: any) => {
        let prefix = "";
        let color = "gray";
        if (rowData.addedBy?.startsWith("C-")) {
            prefix = "C";
            color = '#5e8ad1';
        } else if (rowData.addedBy?.startsWith("SV-")) {
            prefix = "SV";
            color = "#e37f7d";
        } else if (rowData.addedBy?.startsWith("IH-")) {
            prefix = "IH";
            color = "#ab7de3";
        }
        return (
            rowData.addedBy != null ?
                <span style={{ backgroundColor: color, color: "white", padding: "5px 10px", borderRadius: "5px", fontWeight: "bold" }} >
                    {rowData.addedBy}
                </span> : null
        );
    };

    const editedByTemplate = (rowData: any) => {
        let prefix = "";
        let color = "gray";
        if (rowData.editedBy?.startsWith("C-")) {
            prefix = "C";
            color = '#5e8ad1';
        } else if (rowData.editedBy?.startsWith("SV-")) {
            prefix = "SV";
            color = "#e37f7d";
        } else if (rowData.editedBy?.startsWith("IH-")) {
            prefix = "IH";
            color = "#ab7de3";
        }
        return (
            rowData.editedBy != null ?
                <span style={{ backgroundColor: color, color: "white", padding: "5px 10px", borderRadius: "5px", fontWeight: "bold" }} >
                    {prefix} - {rowData.editedBy.replace(/^(C-|SV-|IH-)/, "")}
                </span> : null
        );
    };

    const verifiedByTemplate = (rowData: any) => {
        let prefix = "";
        let color = "gray";
        if (rowData.verifiedBy?.startsWith("IH-")) {
            prefix = "IH";
            color = "#ab7de3";
        }

        return (
            rowData.verifiedBy != null ?
                <span style={{ backgroundColor: color, color: "white", padding: "5px 10px", borderRadius: "5px", fontWeight: "bold" }} >
                    {prefix} - {rowData.verifiedBy.replace(/^(C-|SV-|IH-)/, "")}
                </span> : null
        );
    };

    useEffect(() => {
        if (tableLoad) {
            loadTableData();
            setTableLoad(false);
        }
    }, [filter]);

    return (
        <>
            <Toolbar className="mb-1 py-0" ></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filter={filter} setFilter={setFilter} onSearch={() => setTableLoad(true)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Name" style={{ minWidth: '140px' }} />
                <Column field="client" header="Client" />
                <Column field="end_Client" header="End Client" />
                <Column field="recruiter_Name" header="Recruiters" />
                <Column field="company_Name" header="Recruiters Com(Branch)" />
                <Column field="sales_Name" header="Sales Manager" />
                <Column field="vendor" header="Vendor" />
                {/* <Column field="fromDate" header="From Date" body={fromDate} /> */}
                <Column field="fromDate" header="From Date" style={{ minWidth: '140px' }} sortable body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="toDate" header="To Date" style={{ minWidth: '140px' }} sortable body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="start_Date" header="Start Date" style={{ minWidth: '140px' }} sortable body={(rowData: any) => safeFormatDate(rowData.start_Date, "dd/MM/yyyy", DateFormat)} />

                {/* <Column field="toDate" header="To Date" body={toDate} />
                <Column field="start_Date" header="Start Date" body={startDate} /> */}
                <Column field="workHours" header="Hours" />
                <Column field="addedBy" header="Added By" body={addedByTemplate} />
                <Column field="editedBy" header="Edited By" body={editedByTemplate} />
                <Column field="verifiedBy" header="Verified By" body={verifiedByTemplate} />
                <Column field="verify_Status" header="Status" body={status} />
            </DataTable>
            <Toast ref={toast} />
        </>
    );
}
